import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import { Link } from 'react-router-dom';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import { grey400 } from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Dropzone from 'react-dropzone';
import { Avatar, Paper, Subheader } from 'material-ui';
import { fetchApp } from '../../../store/apps/actions';
import {
    deleteQuiz,
    deleteQuizPicture,
    getQuizzes,
    postQuizPicture,
} from '../../../store/quizzes/actions';
import withTranslation from '../../../hoc/withTranslation';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import styles from './QuizPage.css';
import AdminService, { ADMIN } from '../../../services/admin';
import { EDIT_QUIZ_PAGE, QUIZZES_PAGE } from '../../../constants/routes';
import style from '../../../styles/styles';
import Mapbox from '../../../components/openexplore/Mapbox/Mapbox';
import QuizInfo from '../../../components/quiz/QuizInfo/QuizInfo';
import QuestionInfo from '../../../components/quiz/QuestionInfo/QuestionInfo';
import { EXTERNAL } from '../../../constants/sources';
import ImportIndicator from '../../../components/import/ImportIndicator';

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={grey400} />
    </IconButton>
);

export class QuizPage extends React.Component {

    static propTypes = {
        history: PropTypes.object,
        app: PropTypes.object,
        appPending: PropTypes.bool,
        quizzesPending: PropTypes.bool,
        quizzesSending: PropTypes.bool,
        quizzes: PropTypes.object,
        currentLang: PropTypes.string,
        fetchApp: PropTypes.func,
        getQuizzes: PropTypes.func,
        deleteQuiz: PropTypes.func,
        postQuizPicture: PropTypes.func,
        deleteQuizPicture: PropTypes.func,
        t: PropTypes.func,
        match: PropTypes.object,
    };
    state = {
        quiz: null,
        openRemoveQuiz: false,
        openRemoveQuizPicture: false,
        uploadingFiles: [],
        latlng: null
    };

    compareQuizId = (qu) => {
        return qu.id === this.props.match.params.quizId;
    };

    handleOpenRemoveQuiz = () => {
        this.setState({ openRemoveQuiz: true });
    };

    handleCloseRemoveQuiz = () => {
        this.setState({ openRemoveQuiz: false });
    };

    handleOpenRemoveQuizPicture = () => {
        this.setState({ openRemoveQuizPicture: true });
    };

    handleCloseRemoveQuizPicture = () => {
        this.setState({ openRemoveQuizPicture: false });
    };

    handleRemoveQuiz = () => {
        this.props.deleteQuiz(this.props.app, this.state.quiz, this.props.currentLang)
            .then(() => {
                this.props.history.push(QUIZZES_PAGE.replace(':appId', this.props.app.id));
            });
    };

    handleRemoveQuizPicture = () => {
        this.props.deleteQuizPicture(this.props.app, this.state.quiz, this.props.currentLang)
            .then(() => {
                this.setState({
                    openRemoveQuizPicture: false,
                    quiz: this.props.quizzes[this.props.currentLang]
                        .find(this.compareQuizId),
                });
            });
    };

    handlePictureDrop = (accepted, rejected) => {
        this.setState({ uploadingFiles: [] });

        accepted.forEach((picture) => {
            this.setState({ uploadingFiles: [] });
            console.log('Uploading file ' + picture.name);
            this.props.postQuizPicture(
                this.props.app,
                this.state.quiz,
                picture,
                this.props.currentLang,
                (progressEvent) => {
                    const percentCompleted = Math.round((
                        progressEvent.loaded * 100
                    ) / progressEvent.total);
                    const uploadingState = this.state.uploadingFiles.filter((mediaPercent) => mediaPercent.media
                        !== picture);
                    console.log(picture.name
                        + ' -> '
                        + percentCompleted
                        + '% ('
                        + progressEvent.loaded
                        + ' / '
                        + progressEvent.total
                        + ')');
                    this.setState({
                        uploadingFiles: [
                            ...uploadingState,
                            {
                                picture: picture,
                                percent: percentCompleted,
                            },
                        ],
                    });
                },
            ).then(() => {
                this.setState({
                    quiz: this.props.quizzes[this.props.currentLang].find(this.compareQuizId),
                });
            });
        });
    };

    componentWillMount() {
        this.fetchApplication();
        if (this.props.quizzes[this.props.currentLang].length > 0) {
            let quiz = this.props.quizzes[this.props.currentLang].find(this.compareQuizId);
            this.setState({
                quiz: quiz,
                latlng: quiz && quiz.latitude && quiz.longitude
                    ? {
                        lat: quiz.latitude,
                        lng: quiz.longitude,
                        shouldCenter: true
                    }
                    : null
            });
        } else if (this.props.app && this.props.currentLang) {
            this.props.getQuizzes(this.props.app, this.props.currentLang);
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;
            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    componentWillReceiveProps(nextProps) {
        const lang = nextProps.currentLang;
        if ((
            this.props.match !== nextProps.match || !this.props.app
        ) && !nextProps.appPending) {
            this.fetchApplication(nextProps.match.params.appId);
        }
        if (nextProps.app && !this.state.quiz && !nextProps.quizzesPending) {
            if (nextProps.quizzes[lang].length > 0) {
                    const quiz = nextProps.quizzes[lang].find(function (qu) {
                        return qu.id === nextProps.match.params.quizId;
                    });
                this.setState({
                    quiz: quiz,
                    latlng: quiz && quiz.latitude && quiz.longitude
                    ? {
                        lat: quiz.latitude,
                        lng: quiz.longitude,
                        shouldCenter: true
                    }
                    : null
                });
            } else {
                this.props.getQuizzes(nextProps.app, nextProps.currentLang);
            }
        }
        if (nextProps.quizzesQuestionSending === null && this.props.quizzesQuestionSending !== null) {
            const newQuiz = nextProps.quizzes[nextProps.currentLang].find(function (qu) {
                return qu.id === nextProps.match.params.quizId;
            });
            this.setState({
                quiz: newQuiz,
            });
        }
    }

    renderMenu() {
        let menu;
        if (AdminService.isAuthorized(ADMIN, this.props.user)) {
            menu = (
                <IconMenu
                    style={styles.buttons}
                    iconButtonElement={iconButtonElement}
                    anchorOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}
                    targetOrigin={{
                        horizontal: 'right',
                        vertical: 'top',
                    }}>
                    <Link
                        to={EDIT_QUIZ_PAGE
                            .replace(':appId', this.props.app.id)
                            .replace(':quizId', this.state.quiz.id)
                        }
                    >
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                    <MenuItem onClick={this.handleOpenRemoveQuiz}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                    {this.state.quiz.picture &&
                        <MenuItem onClick={this.handleOpenRemoveQuizPicture}>
                            {this.props.t('generic.remove_picture')}
                        </MenuItem>}
                </IconMenu>
            );
        }
        return menu;
    };

    renderDeleteQuizDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.quizzesSending}
                onClick={this.handleCloseRemoveQuiz}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.quizzesSending}
                onClick={this.handleRemoveQuiz}
            />,
        ];
        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveQuiz}
                onRequestClose={this.handleCloseRemoveQuiz}
            >
                {this.props.quizzesSending && <Loading paper={false} />}
                {!this.props.quizzesSending &&
                    <p>{this.props.t('module.quiz.delete_quiz_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderDeleteQuizPictureDialog() {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.quizzesSending}
                onClick={this.handleCloseRemoveQuizPicture}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.quizzesSending}
                onClick={this.handleRemoveQuizPicture}
            />,
        ];
        return (
            <Dialog
                actions={actions}
                modal={false}
                open={this.state.openRemoveQuizPicture}
                onRequestClose={this.handleCloseRemoveQuizPicture}
            >
                {this.props.quizzesSending && <Loading paper={false} />}
                {!this.props.quizzesSending &&
                    <p>{this.props.t('module.quiz.delete_quiz_picture_confirmation')}</p>
                }
            </Dialog>
        );
    }

    renderPicture() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <Dropzone
                    ref={(node) => {
                        this.dropzoneRef = node;
                    }}
                    accept={QuizPage.supportedDropFiles}
                    onDrop={this.handlePictureDrop}
                    multiple={false}
                    style={{ overflow: 'hidden' }}
                >
                    <Avatar
                        icon={this.state.quiz.picture && <img
                            src={this.state.quiz.picture} alt=""
                            style={style.image.contain} />}
                        size={75}
                        backgroundColor={grey400}
                        style={styles.avatar}
                    />
                </Dropzone>
            </div>
        );
    }

    renderMap() {
        if (this.state.latlng === null) {
            return null;
        }
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <Paper>
                    <Subheader style={{ ...style.subHeader, ...style.relative }}>
                        {this.props.t('generic.map')}
                    </Subheader>
                    <Mapbox
                        latlng={this.state.latlng}
                        scrollWheelZoom={false}
                        canShowDetail={false}
                        style={styles.map}
                        mapStyle={this.props.mapStyle}
                    />
                </Paper>
            </div>
        );
    }

    renderInformation() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <QuizInfo quiz={this.state.quiz} app={this.props.app} lang={this.props.currentLang} />
            </div>
        );
    }

    renderQuestions() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                <Paper style={{ paddingBottom: '10px' }}>
                    <Subheader style={{ ...style.subHeader, ...style.relative }}>
                        {this.props.t('module.quiz.questions')}
                    </Subheader>
                    {this.state.quiz.quiz_questions.map(question => {
                        return <QuestionInfo
                            app={this.props.app}
                            question={question}
                            quiz={this.state.quiz}
                            key={question.id}
                        />;
                    })}
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (
            this.props.app === undefined
            || this.props.app === null
            || this.state.quiz === undefined
            || this.state.quiz === null
        ) {
            return <Loading paper={false} />;
        }
        return (
            <div style={styles.container}>
                {this.state.quiz.source === EXTERNAL ? <ImportIndicator /> : null}
                {this.renderMenu()}
                {this.renderDeleteQuizDialog()}
                {this.renderDeleteQuizPictureDialog()}
                <h3 style={style.navigation}>
                    {this.props.t('module.quiz.quizzes')} / {this.props.t('generic.detail')} - {this.state.quiz.name}
                </h3>
                <div className="row">
                    {this.renderPicture()}
                    {this.renderMap()}
                    {this.renderInformation()}
                    {this.renderQuestions()}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        mapStyle: state.ui.mapStyle,
        appPending: state.apps.pending,
        error: state.apps.error || state.quizzes.error,
        quizzesPending: state.quizzes.pending,
        quizzesSending: state.quizzes.sending,
        quizzes: state.quizzes.content,
        currentLang: state.ui.currentLang,
        quizzesQuestionSending: state.quizzes.questionSending,
        user: state.auth.content,
    };
    if (state.apps.currentApplication) {
        props.app = state.apps.currentApplication;
    }
    return props;
}

export default connect(mapStateToProps, {
    fetchApp,
    getQuizzes,
    deleteQuiz,
    postQuizPicture,
    deleteQuizPicture,
})(withRouter(withTranslation(QuizPage)));



// WEBPACK FOOTER //
// src/containers/quiz/QuizPage/QuizPage.js